import React, { useState } from 'react';
import { useExperience } from '../../contexts/ExperienceContext';
import { competitorAreas } from '../../data/journeys';
import { needById } from '../../data/needs';
import { brand } from '../../data/palette';
import { ChoiceList } from '../ui/ChoiceList';
import { DentalArch, type ArchMode } from '../ui/DentalArch';
import { Eyebrow, Stage, StageTitle } from '../ui/Stage';
import type { Choice } from '../../types/filtek';
const archModes: Record<string, ArchMode> = {
  anterior: 'anterior',
  everyday: 'everyday',
  posterior: 'posterior',
  flowable: 'cervical',
  'complex-shade': 'shade',
  other: 'none',
  nowhere: 'all'
};

/** Where another brand is still in the drawer — asked without judgement. */
export function CompetitorStage() {
  const {
    signals,
    update,
    next,
    direction
  } = useExperience();
  const [pending, setPending] = useState<string | undefined>();
  const [preview, setPreview] = useState<Choice | undefined>();
  const activeId = pending ?? signals.competitorArea;
  const shown = preview?.id ?? activeId;
  const shownChoice = competitorAreas.find(choice => choice.id === shown);
  const accent = shownChoice?.need ? needById(shownChoice.need).accent : brand.lime;
  const pick = (choice: Choice) => {
    if (pending) return;
    setPending(choice.id);
    update({
      competitorArea: choice.id
    });
    window.setTimeout(next, 700);
  };
  return <Stage direction={direction} className="min-h-screen py-28 sm:py-32" labelledBy="competitor-title" data-id="element-187" data-mp="16t64f7wof13e">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-center lg:gap-20" data-id="element-188" data-mp="1av1282feewcf">
        <div data-id="element-189" data-mp="x2bb5jl0j18g">
          <Eyebrow accent={accent} data-id="element-190" data-mp="x2uvt821s3q6">Honest question</Eyebrow>
          <StageTitle id="competitor-title" size="display-sm" className="mt-7 max-w-md" data-id="element-191" data-mp="121xpjwckuniu">
            Where do you still reach for another brand?
          </StageTitle>
          <p className="mt-7 max-w-sm text-base font-light leading-relaxed text-mute" data-id="element-192" data-mp="1pq76okyuin3n">
            No wrong answer. Most practices have one drawer that belongs to someone else.
          </p>

          <DentalArch mode={shown ? archModes[shown] : 'none'} accent={accent} className="mt-10 hidden h-auto w-full max-w-md lg:block" data-id="element-193" data-mp="24co1vjb1j3ag" />
        </div>

        <ChoiceList choices={competitorAreas} selected={activeId} accent={accent} onSelect={pick} onHover={setPreview} showIndex={false} data-id="element-194" data-mp="1uinqx0t2v3tt" />
      </div>
    </Stage>;
}